import { Model } from "@/models/base/model";

export class Diseases extends Model {
  constructor(params: any = {}) {
    super(params);
  }

  // 病気一覧取得
  async getAllDiseases(): Promise<any> {
    this.url = "/cms/api/diseases/group";
    return super.fetch();
  }
}
